const React = require('react');

class PropertyList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {properties} = this.props;
        return (
        <section className="propertyList">
            <div className="propertyList__container">
                <div className="propertyList__flexContainer">
                    {properties.map(property => {
                        return (
                        <div className="propertyList__propertyContainer">
                            <div className="propertyList__property">
                                <a className="propertyList__imageContainer" href={property.link}>
                                    <img src={property.data.listImage}/>
                                </a>
                                <span className="propertyList__information">
                                    {(property.data.address) ? (
                                    <h2 className="propertyList__header">{property.data.address}</h2>
                                    ) : (
                                    <h2 className="propertyList__header">{property.displayName}</h2>
                                    )}

                                    {(property.data.postalCode && property.data.city) && property.data.postalCode + ' ' + property.data.city}
                                    <a href={property.link}>les mer</a>
                                </span>
                            </div>
                        </div>
                        )
                    })}
                </div>
            </div>
        </section>
        )
    }
}

module.exports = PropertyList;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/property-list/Component/index.jsx